import { Component, HostBinding, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { FollowUpTableDialog } from 'entity/dialogs/follow-up-table/follow-up-table.dialog';

@Component({
  selector: 'app-entity-avatar',
  templateUrl: `./entity-avatar.component.html`
})
export class EntityAvatarComponent {
  @Input() size: 'lg' | 'md' | 'sm' | 'xs' = 'md';
  @Input() isUser: boolean;
  @Input() assessmentLevel: number;
  @Input() spotlightIcon: string;

  @Input() entityTypeId: string; // required
  @Input() entityId: string;
  @Input() campaignId: string;

  @HostBinding('class') get avatarSizeClass() {
    return 'avatar-size-'+this.size;
  }

  /**
   *
   */
  constructor(
    private _dialog: MatDialog
  ) {
  }

  // NOTE: It seems this was removed from the layout at some point to make room
  // for spotlights. The flag gets shown in some other places.
  showFollowUpDetailsClick(event: MouseEvent) {
    event.stopImmediatePropagation();
    FollowUpTableDialog.open(this._dialog, {
      data: { campaignId: this.campaignId, entityId: this.entityId }
    });
  }
}
